// src/store/modules/accordion.js

const generateInitialItems = () => {
  const items = [
    { id: 1, title: "Planning Your Next Adventure", content: "Exploring new destinations requires careful preparation. Pack essential items and research local customs to make the most of your journey." },
    { id: 2, title: "The Art of Coffee Brewing", content: "Mastering coffee brewing is a delicate balance of temperature, timing, and technique. Fresh beans and proper grinding make all the difference in creating the perfect cup." },
    { id: 3, title: "Understanding Modern Architecture", content: "Contemporary buildings blend form and function in innovative ways. Sustainable materials and efficient designs shape the future of urban landscapes." },
    { id: 4, title: "Gardening Through the Seasons", content: "Each season brings unique challenges and opportunities for gardeners. Understanding plant cycles helps create a vibrant and sustainable garden." },
    { id: 5, title: "The Science of Baking", content: "Baking combines chemistry and creativity. Precise measurements and temperature control transform simple ingredients into delicious treats." },
    { id: 6, title: "Digital Photography Basics", content: "Mastering composition and lighting is essential in photography. Modern cameras offer powerful tools for capturing memorable moments." },
    { id: 7, title: "Mindful Living Practices", content: "Daily meditation and mindfulness exercises can reduce stress and improve focus. Small changes in routine can lead to significant lifestyle improvements." },
    { id: 8, title: "The World of Classic Literature", content: "Timeless stories continue to resonate with modern readers. These works offer insights into human nature and society's evolution." },
    { id: 9, title: "Sustainable Living Tips", content: "Small changes in daily habits can make a big environmental impact. Reducing waste and choosing eco-friendly products helps preserve our planet." },
    { id: 10, title: "Music Theory Fundamentals", content: "Understanding scales and chord progressions opens new creative possibilities. Music theory provides the foundation for composition and improvisation." }
  ];
  return items;
};

export const accordionModule = {
  namespaced: true,
  
  state: {
    items: generateInitialItems(),
    expandedPanels: []
  },

  mutations: {
    UPDATE_ITEMS_ORDER(state, newItems) {
      state.items = newItems;
    },
    SET_EXPANDED_PANELS(state, panels) {
      state.expandedPanels = panels;
    }
  },

  actions: {
    updateItemsOrder({ commit }, newItems) {
      commit('UPDATE_ITEMS_ORDER', newItems);
    },
    setExpandedPanels({ commit }, panels) {
      commit('SET_EXPANDED_PANELS', panels);
    }
  },

  getters: {
    getItems: state => state.items,
    getExpandedPanels: state => state.expandedPanels
  }
};